module.exports = __webpack_public_path__ + "img/stone2.71edb21f.jpg";